module.exports = __webpack_public_path__ + "static/media/country_gu.e9585778.webp";